import { Text as Component, TextProps } from '@react-email/components'

export const Text = (
  props: Omit<TextProps, 'children'> & { children?: any }
) => {
  const { children, style, ...rest } = props
  return (
    <Component
      {...rest}
      style={{
        ...style
      }}
    >
      {children}
    </Component>
  )
}

export default function Preview() {
  return <Text>Typography</Text>
}
